import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchHomeData } from "./homeAPI";
export interface AnnualState {
  annualData: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: AnnualState = {
  annualData: {},
  status: "idle",
};

export const GetAnnualData = createAsyncThunk("user/fetchHomeData", async (id:any) => {
  const response = await fetchHomeData(id);
  return response;
});

export const annualSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetAnnualData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetAnnualData.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetAnnualData.fulfilled, (state, action) => {
        state.status = "success";
        state.annualData = action.payload.annual;
      });
  },
});

export const {} = annualSlice.actions;

export const selectAnnualData = (state: RootState) => {
  return state.annual.annualData;
};

export default annualSlice.reducer;
